import { MaybeAsync } from '@angular/router';
import { values, identity } from 'lodash';
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { WorkOrderUnsavedChangesDialogComponent, WorkOrderUnsavedChangesDialogData } from '@shared/components/work-order-unsaved-changes-dialog/work-order-unsaved-changes-dialog.component';
import { map } from 'rxjs';

export interface HasUnsavedWorkOrderChanges {
  getUnsavedChanges(): WorkOrderUnsavedChangesDialogData;
}

export const unsavedWorkOrderChangesGuard = (component: HasUnsavedWorkOrderChanges): MaybeAsync<boolean> => {
  const unsavedChangesState = component.getUnsavedChanges();
  const hasUnsavedChanges = values(unsavedChangesState).some(identity);

  if (!hasUnsavedChanges) {
    return true;
  }

  return inject(MatDialog).open<WorkOrderUnsavedChangesDialogComponent, WorkOrderUnsavedChangesDialogData, boolean>(
    WorkOrderUnsavedChangesDialogComponent,
    { data: unsavedChangesState },
  ).afterClosed().pipe(
    map(confirmed => confirmed === true),
  );
};
